import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    savedCardResponseHandler?: (response: any) => void;
    acceptJSResponseHandler?: (response: any) => void;
    AcceptUI?: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AcceptJSService {
  constructor() {}

  injectScript() {
    console.log('injecting AcceptJS script');
    // script must be loaded after the component is mounted in the DOM
    // and the payment form exists. Accept.js binds the click event of the form
    // button on load, so the form must exist before the script is loaded.
    const src = environment.production
      ? 'https://js.authorize.net/v3/AcceptUI.js'
      : 'https://jstest.authorize.net/v3/AcceptUI.js';

    console.log('AcceptJS script src:', src);

    const script = document.createElement('script');
    script.id = 'accept-js-script';
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }

  removeScript() {
    let script = document.getElementById('accept-js-script');
    while (script) {
      script.remove();
      script = document.getElementById('accept-js-script');
    }

    // remove any existing event handlers
    if (window.acceptJSResponseHandler) {
      delete window.acceptJSResponseHandler;
    }
    if (window.savedCardResponseHandler) {
      delete window.savedCardResponseHandler;
    }
    if (window.AcceptUI) {
      delete window.AcceptUI;
    }

    // remove any Accept.js elements
    const ids = ['AcceptUIBackground', 'AcceptUIContainer'];
    for (const id of ids) {
      let el = document.getElementById(id);
      while (el) {
        el.remove();
        el = document.getElementById(id);
      }
    }

    const classes = ['AcceptUI'];
    for (const className of classes) {
      const els = document.getElementsByClassName(className);
      for (let i = 0; i < els.length; i++) {
        els[i].remove();
      }
    }
  }
}
